import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  // baseURL:'https://backend-i9kq.onrender.com/',
  'https://peercampus.onrender.com/';

//create axios instance with base url
const api = axios.create({
    baseURL: API_BASE_URL,
    headers:{
        'Content-Type':'application/json',
    },
    withCredentials: true, // crucial for cookies
});

api.interceptors.request.use(
  (config) => {
    // HTTP-only cookies are automatically included by the browser
    // No need to manually set Authorization headers

        // In local dev, cookie auth often won't work cross-origin due to SameSite rules.
        // Ensure header-based JWT works reliably (Axios v1 may use AxiosHeaders).
        try {
            const token =
                localStorage.getItem('access_token') ||
                localStorage.getItem('token') ||
                localStorage.getItem('access');

            if (token) {
                config.headers = config.headers || {};

                // Axios v1 may use an AxiosHeaders instance.
                if (typeof config.headers.set === 'function') {
                    config.headers.set('Authorization', `Bearer ${token}`);
                } else {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
            }
        } catch {
            // ignore
        }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle auth errors only
api.interceptors.response.use(
    (response) => {
        // If backend returns tokens, persist them centrally.
        // This makes login flows consistent across pages.
        try {
            const data = response?.data;
            if (data?.access) {
                localStorage.setItem('access_token', data.access);
            }
            if (data?.refresh) {
                localStorage.setItem('refresh_token', data.refresh);
            }
        } catch {
            // ignore
        }
        return response;
    },
  (error) => {
    // If we get a 401, just redirect to login
        if (error.response?.status === 401) {
            const reqUrl = (error.config?.url || '').toString();
            // Let explicit logout handlers control navigation.
            if (reqUrl.includes('users/logout')) {
                return Promise.reject(error);
            }

      console.error('Authentication failed. Redirecting to login.');
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
            } catch {}
            try {
                sessionStorage.clear();
            } catch {}

            const path = window.location.pathname || '';
            const isOnAuthPage = path.startsWith('/login') || path.startsWith('/signup');
            if (!isOnAuthPage) {
                window.location.replace('/login');
            }
    }
    
    return Promise.reject(error);
  }
);

// http request handle
const get = async(url, params={}, headers={}) =>{
    try {
        const response = await api.get(url, {params, headers});
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data :error;
    }
}

const post = async(url, data={},headers={})=>{
    try {
        const response = await api.post(url, data, {headers});
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data :error;
    }
};

const put = async(url, data={}, headers={})=>{
    try {
        const response = await api.put(url, data, {headers});
        return response.data
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

const patch = async(url, data={}, headers={})=>{
    try {
        const response = await api.patch(url, data, {headers});
        return response.data
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

const del = async(url, headers={})=>{
    try {
        const response = await api.delete(url, {headers});
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data :error;
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get,
    post,
    put,
    patch, // Add this line
    delete:del,
};
